import type { TFunction } from 'i18next';

import { timeLineHintsForGrid as stageHintForGrid } from '../../../pok/components/TimeLine/HintsSearch';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import {
  CreateUpdateStageHintDto,
  CreateUpdateStageHintDtoFromJSON,
  DefaultApi,
  GetLastEditorDto,
  GetStageHintDto,
} from '../autogenerated/pokApiClient';
import { validateAgainst } from '../validation/validateAgainst';
import { StageHintSchema } from '../validation/schemas';
import { TKeys } from '../../../translations';

export interface StageHintContextInterface {
  getById: (id: string) => Promise<GetStageHintDto>;
  getHintsForStage: (stageId: string) => Promise<GetStageHintDto[]>;
  getAllByPortion: (
    t: TFunction<'projectLng', 'projectLng'>,
    tk: TKeys<'projectLng'>,
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, filterColumns?: string) => Promise<number>;
  update: (
    id: string,
    dto: CreateUpdateStageHintDto,
  ) => Promise<GetStageHintDto>;
  create: (dto: CreateUpdateStageHintDto) => Promise<GetStageHintDto>;
  getLastEditor: (id: string) => Promise<GetLastEditorDto>;
}

export const StageHintContext = (api: DefaultApi) => {
  return {
    getById: (id: string) => api.stageHintControllerGetById(id),
    getHintsForStage: (stageId: string) =>
      api.stageHintControllerGetHintsByStageDefinitionId(stageId),
    getAllByPortion: async (
      t: TFunction<'projectLng', 'projectLng'>,
      tk: TKeys<'projectLng'>,
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) => {
      const data = await api.stageHintControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        filterColumns,
      );
      return data.map(item => stageHintForGrid(item, t, tk));
    },
    getAllCount: (filterText?: string, filterColumns?: string) =>
      api.stageHintControllerGetAllCount(filterText || '', filterColumns),
    update: (id: string, dto: CreateUpdateStageHintDto) =>
      api.stageHintControllerUpdate(id, dto),
    create: (dto: CreateUpdateStageHintDto) =>
      api.stageHintControllerCreate(dto),
    getLastEditor: (id: string) => api.stageHintControllerGetLastEditor(id),
  };
};

export const validate = (hint: CreateUpdateStageHintDto) =>
  validateAgainst(StageHintSchema, hint);

export const convert = (hint?: GetStageHintDto) => {
  if (!hint) {
    return newStageHint();
  }

  const converted = CreateUpdateStageHintDtoFromJSON(hint);
  converted.stageDefinitionId = hint.stageDefinition?.id;

  return converted;
};

export const newStageHint = () => {
  return CreateUpdateStageHintDtoFromJSON({});
};
